var map = {
	"./decidim/avatar-multiuser.png": 99837,
	"./decidim/brands/google.svg": 19136,
	"./decidim/cc-badge.png": 83915,
	"./decidim/decidim-logo.svg": 43679,
	"./decidim/default-avatar.svg": 51635,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 23897,
	"./decidim/icons.svg": 60610,
	"./decidim/pattern.png": 83425,
	"./decidim/placeholder.jpg": 26836,
	"./decidim/vendor/leaflet/layers-2x.png": 82899,
	"./decidim/vendor/leaflet/layers.png": 52202,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 143,
	"./decidim/vendor/leaflet/marker-icon.png": 78950,
	"./decidim/vendor/leaflet/marker-shadow.png": 40605,
	"./decidim/vendor/social-share-button/delicious.svg": 33085,
	"./decidim/vendor/social-share-button/douban.svg": 76473,
	"./decidim/vendor/social-share-button/email.svg": 93722,
	"./decidim/vendor/social-share-button/facebook.svg": 64818,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 92606,
	"./decidim/vendor/social-share-button/google_plus.svg": 36610,
	"./decidim/vendor/social-share-button/hacker_news.svg": 82554,
	"./decidim/vendor/social-share-button/linkedin.svg": 73608,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 25889,
	"./decidim/vendor/social-share-button/pinterest.svg": 92100,
	"./decidim/vendor/social-share-button/qq.svg": 70200,
	"./decidim/vendor/social-share-button/reddit.svg": 76958,
	"./decidim/vendor/social-share-button/telegram.svg": 82847,
	"./decidim/vendor/social-share-button/tumblr.svg": 88764,
	"./decidim/vendor/social-share-button/twitter.svg": 3951,
	"./decidim/vendor/social-share-button/vkontakte.svg": 91053,
	"./decidim/vendor/social-share-button/wechat.svg": 83536,
	"./decidim/vendor/social-share-button/weibo.svg": 73754,
	"./decidim/vendor/social-share-button/whatsapp.svg": 97584,
	"./decidim/vendor/social-share-button/x.svg": 91034,
	"./decidim/vendor/social-share-button/xing.svg": 88366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10454;